<template>
  <div class="py-10">
    <div :class="'card--item ' + toHover" @click="onClickCard(toHover)">
      <div
        class="card--item-image"
        :style="{
          background: `linear-gradient(135deg, ${event} 0%,${primary} 50%,${secondary} 100%)`
        }"
      >
        <img v-if="image" :src="image" :alt="title" />
        <div
          v-else-if="title"
          class="h-100"
          :style="{
            background: `linear-gradient(135deg, ${event} 0%,${primary} 50%,${secondary} 100%)`
          }"
        ></div>
        <div v-else class="h-100 bg-gray-light"></div>
      </div>
      <div class="card--item-title">
        {{ title }}
        <svg
          v-if="!title"
          xmlns="http://www.w3.org/2000/svg"
          width="160.172"
          height="10"
          viewBox="0 0 160.172 10"
        >
          <rect
            id="Rectangle_41"
            data-name="Rectangle 41"
            width="160.172"
            height="10"
            fill="#efefef"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    }
  },
  computed: {
    toHover() {
      if (this.title) {
        return "card--hover";
      }
      return "";
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    }
  },
  methods: {
    onClickCard(toHover) {
      if (toHover === "card--hover") {
        this.$emit("handleClickCardItem");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  &--hover {
    cursor: pointer;
    &:hover {
      background-color: $gray-500;
      color: white;
    }
  }
  &--item {
    transition: all 0.1s;
    // width: 300px;
    width: 100%;
    padding: 20px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    box-shadow: 0 3px 15px 0px rgba(0, 0, 0, 0.1);
    margin-right: 20px;
    &-title {
      text-align: center;
      padding: 30px 0;
      line-height: 24px;
      font-size: 16px;
    }
    &-image {
      height: 200px;
      width: 100%;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      overflow: hidden;
      background: #efefef;
      img {
        height: 200px;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
